import { ReactElement } from 'react';

export function Button(): ReactElement | null {
  return null;
}
